import styles from '../../../../checkout-generic/payment/shPaymentAction.module.scss';
import GiftSVG from "../../../../../../public/icons/gift.svg";
import { shCurrencyPipe } from "../../../../../../helper/pipes/currency-pipe";

export const ShCheckoutPricetable = (
    {
        title,
        isGiftcard = false,
        discount,
        total,
        start,
        voucherCode,
        className = "",
        children = undefined,
        voucherTag = null
    }
) => {

    return <div className={"mw-card mx-auto mt-3 " + className}>
        <div className={styles.underline}>

            <div className={"d-flex "}>
                <div className="mr-auto tw-flex tw-items-center">
                    {title}

                    {isGiftcard &&
                        <>
                            <GiftSVG className="svg-small ml-2 " data-tip="Gutscheinkauf" data-text-color="#ffffff"
                                     data-background-color="#2a3349" data-place="bottom"/>
                        </>
                    }

                </div>

                {discount > 0 &&
                    <div className="ml-auto">
                        {shCurrencyPipe(start)}
                    </div>
                }
            </div>

            {discount > 0 &&
                <div className={"d-flex text-green "}>
                    <div className="mr-auto">
                        <p className="small-text">
                            Ersparnis {(voucherCode && !voucherTag?.startsWith("2for1")) && ("- Code " + voucherCode)}
                            { voucherTag === "upgrade" && "- Upgrade" }
                        </p>
                    </div>

                    {discount &&
                        <div className="ml-auto">
                            - {shCurrencyPipe(discount)}
                        </div>
                    }
                </div>
            }
        </div>

        <div className="d-flex">
            <div className="mr-auto">
                <p className="title">
                    Fälliger Betrag
                </p>
            </div>

            <div className="ml-auto">
                <p className="title">
                    {shCurrencyPipe(total)}
                </p>
            </div>
        </div>


        {children &&
            <div className={"d-flex"}>
                <p className="small-text ml-auto mt-2 text-right opacity-50">
                    {children}
                </p>
            </div>
        }


    </div>
}
